<template>
  <div v-if="component_done_loading" class="demo-container heightAuto">
    <notifications group="form" :max="1" role="alert" />

    <div class="demoForm">
      <header class="padding30px textAlignCenter">
        <a href="https://www.intedashboard.com">
          <img src="/img/logoNoSlogan.png" alt="Intedashboard Logo" />
        </a>
        <h1 class="mb-0">Try InteDashboard for Free:</h1>
        <h2 class="mt-0">Faculty & Educators</h2>
        <p>
          Try InteDashboard to see how it can work for
          <br />your students and explore the platform firsthand.
          <br />
          <br />
          <strong>Are you a student?</strong>
          <br />
          <a href="https://auth.intedashboard.com"
            >Log in to your InteDashboard student account.</a
          >
        </p>
      </header>

      <main class="padding30px bg-light-blue">
        <kr-field
          :form="form"
          display="First Name"
          name="firstname"
          :options="{ placeholder: '', required: true }"
          class="marginBottom30"
        >
        </kr-field>

        <kr-field
          :form="form"
          display="Last Name"
          name="lastname"
          :options="{ placeholder: '', required: true }"
          class="marginBottom30"
        >
        </kr-field>

        <kr-field
          :form="form"
          display="Email"
          name="email"
          :options="{ type: 'email', placeholder: '', required: true }"
          class="marginBottom30"
        >
        </kr-field>

        <kr-field
          :form="form"
          display="Job Title"
          name="jobTitle"
          :options="{ placeholder: '', required: true }"
          class="marginBottom30"
        >
        </kr-field>

        <kr-field
          :form="form"
          display="Institution Name"
          name="institutionName"
          :options="{ placeholder: '', required: true }"
          class="marginBottom30"
        >
        </kr-field>

        <!-- <kr-radio-multiple
          display="Do you currently teach with TBL?"
          :form="form"
          name="tblStatus"
          :items="[
            {
              value: 'currently teaching',
              description: 'Yes, I teach with TBL',
            },
            { value: 'considering tbl', description: 'No, I am considering' },
          ]"
          item_value_idx="value"
          item_desc_idx="description"
          class="marginBottom20"
          :options="{ required: true }"
        >
        </kr-radio-multiple> -->

        <kr-select
          class="marginBottom30"
          display="How familiar are you with TBL?"
          name="tblStatus"
          :form="form"
          :items="[
            {
              value:
                'Extremely familiar, I have been teaching with TBL for over five years',
              description:
                'Extremely familiar, I have been teaching with TBL for over five years',
            },
            {
              value:
                'Very familiar, I have been teaching with TBL for one to five years',
              description:
                'Very familiar, I have been teaching with TBL for one to five years',
            },
            {
              value:
                'Familiar, I understand the fundamentals of TBL (I am in a non-teaching role)',
              description:
                'Familiar, I understand the fundamentals of TBL (I am in a non-teaching role)',
            },
            {
              value:
                'Somewhat familiar, I am getting started with TBL (I have been teaching with TBL for less than a year)',
              description:
                'Somewhat familiar, I am getting started with TBL (I have been teaching with TBL for less than a year)',
            },
            {
              value: 'Not at all familiar, I want to learn more about TBL',
              description:
                'Not at all familiar, I want to learn more about TBL',
            },
          ]"
          item_value_idx="value"
          item_desc_idx="description"
          :options="{ required: true }"
        >
        </kr-select>

        <kr-field
          :form="form"
          display="What tools do you currently use to conduct your TBL classes?"
          name="tblTools"
          :options="{ placeholder: '' }"
          class="marginBottom30"
        >
        </kr-field>

        <kr-select
          class="marginBottom30"
          display="How did you hear about InteDashboard?"
          name="reference"
          :form="form"
          :items="[
            {
              value: 'Direct email',
              description: 'Direct email',
            },
            {
              value: 'From a colleague/friend',
              description: 'From a colleague/friend',
            },
            {
              value: 'Google Search/Website',
              description: 'Google Search/Website',
            },
            {
              value: 'At a conference/event',
              description: 'At a conference/event',
            },
            {
              value: 'Twitter',
              description: 'Twitter',
            },
            {
              value: 'LinkedIn',
              description: 'LinkedIn',
            },
            {
              value: 'Facebook',
              description: 'Facebook',
            },
            {
              value: 'Other',
              description: 'Other',
            },
          ]"
          item_value_idx="value"
          item_desc_idx="description"
          :options="{ required: true }"
        >
        </kr-select>

        <p class="marginBottom30">
          InteDashboard is committed to protecting and respecting your privacy.
          We would like to contact you about the information you requested, as
          well as other content that may be of interest to you.
        </p>

        <div class="checkboxField flex marginBottom20">
          <input
            type="checkbox"
            id="receiveInteDashboardUpdates"
            v-model="form.model.subscribe"
          />
          <label for="receiveInteDashboardUpdates">
            Subscribe to InteDashboard product updates
          </label>
        </div>

        <p class="marginBottom20">
          You can unsubscribe from these communications at any time. For more
          details, please review our
          <a
            href="https://www.intedashboard.com/privacy-policy"
            class="link"
            target="_blank"
            aria-label="Privacy Policy opens in a new tab."
          >
            Privacy Policy </a
          >.
        </p>

        <p class="marginBottom20">
          By clicking the button below, you consent to InteDashboard storing and
          processing your personal information for the purpose of providing the
          requested information and contacting you about related updates.
        </p>

        <button
          class="btn-large btn-success width100 margin0"
          @click.prevent="demoLogin"
          :disabled="form.isBusy() || !canSend"
        >
          <span v-if="form.isBusy()" class="fa fa-spin fa-spinner"></span>
          <template v-else> Start Team Quiz With Immediate Feedback </template>
        </button>
      </main>
    </div>
  </div>
</template>
<script>
import KrForm from "../../components/forms/form";
import KrAuth from "../../components/auth/auth";
export default {
  created() {
    $("body").addClass("login");
    if (process.env.VUE_APP_DEMO_SIGN_IN_ENABLED == "true") {
      this.form.model.subscribe = false;
      this.component_done_loading = true;
    } else {
      this.$router.push({ name: "errors.403" });
    }
  },
  data() {
    return {
      component_done_loading: false,
      auth: new KrAuth(),

      form: new KrForm({
        fields: {
          type: "default!:demo",
          firstname: "",
          lastname: "",
          email: "",
          jobTitle: "",
          institutionName: "",
          tblStatus: "",
          familiarLevel: "",
          tblTools: "",
          reference: "",
          subscribe: "",
        },
      }),
    };
  },
  methods: {
    demoLogin() {
      var that = this;
      axios
        .post(process.env.VUE_APP_API_SIGN_IN_URL, this.form.model)
        .then(function(response) {
          if (response.data.data.user.role == "demo") {
            response.data.data.user.test = response.data.data.test;
          }
          that.auth.login(
            {
              ...response.data,
              remember: true,
            },
            { demo: true },
          );
        })
        .catch(function(errors) {
          if (_.get(errors, "response.status") == 429) {
            that.$notify({
              group: "form",
              type: "error",
              title: "Error",
              text: "Please try again after a couple of minutes.",
            });
          } else {
            let error = false;
            if ((error = _.get(errors, "response.data.errors", false))) {
              that.form.errors.record(error);
            } else {
              that.$notify({
                group: "form",
                type: "error",
                title: "Error",
                text: "Something went wrong. Please try again later.",
              });
            }
          }
        });
    },
  },
  computed: {
    canSend() {
      if (
        this.form.model.email &&
        this.form.model.firstname &&
        this.form.model.lastname &&
        this.form.model.jobTitle &&
        this.form.model.institutionName &&
        this.form.model.tblStatus &&
        this.form.model.reference
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.demo-container {
  padding: 20px;
  width: 100%;
  overflow: auto;
}

.demoForm {
  margin: 0 auto;
  max-width: 632px;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  border-radius: 24px;
  overflow: hidden;

  .important {
    font-size: 20px;
  }

  img {
    max-width: 100%;
    width: 40%;
  }

  section {
    padding: 30px;

    &.paddingBottom {
      padding-bottom: 16px;
    }
  }

  h1 {
    margin-top: 16px;
    margin-bottom: 16px;
    line-height: 1.15;
    font-size: 33px;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  p {
    font-size: 16px;
  }

  .bg-light-blue {
    background-color: #e9f2ff;
  }

  label,
  .control-label {
    color: #3c3c43;
    font-size: 1rem;
  }

  .important {
    color: #99001c;
  }

  input {
    background: #ffffff;
    border: 1px solid #767676;
    border-radius: 8px;

    &[type="text"] {
      padding: 11px 8px;
      line-height: 1;
    }
  }

  .btn {
    padding: 8px 32px;
  }

  .btn-success {
    --button-bg: #2d8659;
    --button-border: #2d8659;
    --button-c: #fff;

    background-color: var(--button-bg);
    border: 2px solid var(--button-border);
    color: #fff;

    &:hover,
    &:focus:hover {
      background-image: none;
      background-color: #fff;
      border-color: #00582f;
      color: #3c3c43;
    }

    &.in-progress {
      background-color: #a5c9b7;
      border-color: #a5c9b7;
      color: #ffffff;
    }

    &:focus-visible,
    &:focus {
      background-color: var(--button-bg);
      border-color: var(--button-border);
      color: #ffffff;
    }

    &:active,
    &:active:focus {
      background-color: #00582f;
      border-color: #00582f;
      color: #ffffff;
    }

    &:disabled {
      background-color: #efefef;
      border-color: #efefef;
      color: #8b8b8f;
      box-shadow: none;
    }
  }

  .mt-0 {
    margin-top: 0;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  a {
    color: #0e6eb7;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .demo-container {
    padding: 0;

    .demoForm {
      border: none;
      border-radius: 0;

      h1 {
        font-size: 28px;
      }
    }
  }
}

@media (max-width: 630px) {
  .demoForm {
    img {
      width: 100%;
    }
  }
}
</style>
